<template>
    <v-app color="white">
        <v-content >
<!-- ACTIVATE ACCOUNT AND SET PASSWORD -->
        <v-container class="true-center bgzz" fluid>
            <v-row  justify="center">
                <v-col cols="12" sm="12" md="12" class="text-center">
                    <v-card class="text-center max-300" elevation=24 >
                        <v-row>
                            <v-col cols="12" md="12" class="text-center mt-10">
                                <v-icon x-large class="icon-col">mdi-cloud-lock-outline</v-icon>
                            </v-col>
                        </v-row>
                        <v-span class="">
                            <v-span class="txt1 text-center px-3" v-html="$t('zz_housekeeping')"></v-span>
                        </v-span>
                        <v-card-text class="justify-end">
                            <v-col cols="12" md="12" class="text-center">
                                <span v-html="$t('zz_please_set_password')"></span>
                                <v-form id="loginform" >
                                    <v-alert dense text type="error" v-if="authFailed">
                                        {{authMessage}}
                                    </v-alert>
                                    <v-text-field
                                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        v-model="password"
                                        id="password"
                                        label="Enter Password Here"
                                        name="password"
                                        type="password"
                                        :error-messages="errors.collect('password')"
                                        data-vv-name="password"
                                        v-validate="'required'"
                                        required>
                                    </v-text-field>
                                </v-form>
                                <v-btn class="mt-5 py-2 bgzz white--text" @click="resetpassword()">{{$t('zz_save_login')}}</v-btn>
                            </v-col>
                        </v-card-text>
                        <div class=" text-center pb-3 pt-5 col-12">
                            <img :src="juzzapLogo" height="25px"/>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
<!-- EXPIRED LINK -->
        <v-container class="true-center bgzz" fluid>
            <v-row  justify="center">
                <v-col cols="12" sm="12" md="12" class="text-center">
                    <v-card class="text-center max-300" elevation=24 >
                        <v-row>
                            <v-col cols="12" md="12" class="text-center mt-10">
                                <v-icon x-large class="icon-col">mdi-clock-alert-outline</v-icon>
                            </v-col>
                        </v-row>
                        <v-span class="">
                            <v-span class="txt1 text-center px-3" v-html="$t('zz_expired_link1')"></v-span>
                        </v-span>
                        <v-card-text class="justify-end">
                            <v-col cols="12" md="12" class="text-center">
                                <div class="py-3" v-html="$t('zz_expired_link2')"></div>
                                <div class="py-3" v-html="$t('zz_expired_link3')"></div>
                                <!-- <div class="txt1" v-html="$t('zz_juZZap')"></div> -->
                                <v-container class="pa-0 ma-0">
                                <v-btn class="bgzz white--text px-2 mx-2 px-1 mb-5">{{$t('zz_log_in')}}</v-btn><br>
                                <v-btn x-small outlined class="px-2 ma-2 px-1">{{$t('zz_reset_password')}}</v-btn>
                                </v-container>
                            </v-col>
                        </v-card-text>
                        <div class=" text-center pb-3 pt-5 col-12">
                            <img :src="juzzapLogo" height="25px"/>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-overlay v-model="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-container>
        <!-- <v-content > -->
            <v-container class="pa-0" fluid >
                <v-row  justify="center">
                    <v-col cols="12" sm="12" md="12" class="pt-0 text-center ">
                        <v-card class=" " elevation=0 >
                            <v-card-text class=" mt-50 pa-0 justify-end">
                                <v-card flat tile v-if="showLogin && forgettype==false" class="ml-auto mr-auto mb-3 mt-5" max-width="90%">
                                    <v-overlay v-model="overlaylogin" >
                                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                                    </v-overlay>
                                    <v-card-text>
                                        <v-form id="loginform" class=""   >
                                            <v-alert dense text type="error" v-if="authFailed">
                                                {{authMessage}}
                                            </v-alert>
                                            <v-text-field
                                                filled
                                                v-model="email"
                                                label="E-mail"
                                                name="email"
                                                prepend-inner-icon="person"
                                                type="email"
                                                v-validate="'required|email'"
                                                :error-messages="errors.collect('email')"
                                                data-vv-name="email"
                                                required
                                            ></v-text-field>
                                            <v-text-field
                                                filled
                                                v-model="password"
                                                id="password"
                                                label="Password"
                                                name="password"
                                                prepend-inner-icon="lock"
                                                autocomplete="new-password"
                                                type="password"
                                                :error-messages="errors.collect('password')"
                                                data-vv-name="password"
                                                v-validate="'required'"
                                                required
                                            ></v-text-field>
                                            <v-row>
                                                <v-col cols="6" md="6" class="text-center" >
                                                    <v-btn color="primary" @click.prevent="forgettype=false;showLogin=false;" max-width="100%">Cancel</v-btn>
                                                </v-col>
                                                <v-col cols="6" md="6" class="text-center" >
                                                    <v-btn color="primary" @click.prevent="submitlogin" max-width="100%">Login</v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="12" class="text-center" >
                                                    <a color="primary" @click.prevent="forgettype=true" max-width="100%">Forget Password ?</a>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
        <v-footer color="white" fixed>
            <v-container fluid>
                <v-row class="" v-if="!showLogin">
                    <v-col cols="12" md="12" class="text-center pa-0">
                        <!-- <v-btn  color="primary"  @click="showLoginwindow">Login</v-btn> -->
                        <v-btn  color="primary"  @click="showLogin=!showLogin">{{$t('zz_log_in')}}</v-btn>
                        <!-- <a @click="showLoginwindow" class="red--text">Login</a> -->
                        </v-col>
                </v-row>
            </v-container>
        </v-footer>
    </v-app>


</template>
<script>

import Vue from 'vue'
import VeeValidate from "vee-validate";

import {TheMask} from 'vue-the-mask'

Vue.use(VeeValidate);
export default {
    props: {
    source: String
  },
  data: vm => ({
      overlay:false,
      overlaylogin:false,
      passwordreset:false,
      forgettype:false,
      forgetemail:'',
      codeError:false,
      valid: true,
      thumb:require('@/assets/Glovethumb.svg'),
    //   juzzapLogo:require('@/assets/juzzap-logo.svg'),
      juzzapLogoNew:require('@/assets/confirm-logo.svg'),
      logo:require('@/assets/logo.png'),
      juzzapLogo: require("@/assets/juZZap-orange.svg"),
      whitejuzzapLogo: require("@/assets/logos/juZZap-filled-white-100H.svg"),

    //   bannerImg:require('@/assets/restaurant.png'),
      bannerImg:require('@/assets/restaurant.svg'),

      businesscode:'',
      businesscode2:'',
      businesscode1:'',
      businesscode3:'',

      showLogin:false,
      hideLogin:false,

        email: '',
        password: '',
        authFailed: false,

        authMessage: "",

        emailFailed:false,
        emailMessage:"",

        drawer: null,
        code:"",
        codeexist:false,

      dictionary: {
      attributes: {
        businesscode: "Business Code",
        email: "E-mail Address"
        // custom attributes
       },
      custom: {},
    },
      userid:0,
      user:[],


  }),
    created()
    {
        this.userid=localStorage.getItem("userid")
    },
    mounted()
    {
        //this.$validator.localize("en", this.dictionary);
    },
    components: {TheMask},
    computed:
    {
        //   isAuthorised() {
        //   return this.$store.getters.isLoggedin;
        // },
        //   businesscode:function(){
        //       return this.businesscode1+'-'+this.businesscode2+'-'+this.businesscode3;
        //   }
    },



  methods:
  {
    resetpassword()
    {
        this.userid=localStorage.getItem("userid");

        this.overlay=true;

        this.$http
          .post(this.$apidomain+"passwordUpdate/"+ this.userid,{password:this.password})
          .then(res => {
              if(res.data.success==1)
                  {

                    //   this.$router.go('/');

                     this.overlay=false;

                      this.user=res.data.user;

                      this.email=res.data.user.email;

                      this.submitlogin();
                  }
              //console.log("types "+ this.types);
          })
          .catch(err => {
                     this.overlay=false;

              console.log(err.response);
          });
    },
    showLoginwindow()
    {
        this.$router.push({name:'frontnew'});

    },
    sendemail()
    {
        this.forgettype=true;

        let fd = new FormData(document.getElementById("forgetpasswordform"));

            this.$http
            .post(this.$apidomain+"forgetpassword",fd)
            .then(res => {
                if (res.data.success == 1)
                {
                    //this.$router.push({name:'businesshome',params:{code: this.businesscode.trim(),type:'uc',key:this.getCookie('jzuserkey')}});
                    //this.$router.push({name:'bDetails',params:{tag:  this.businesscode,key:this.getCookie('jzuserkey')}});

                    //this.$router.go();

                    this.forgettype=false;
                    this.passwordreset=true;
                    this.showLogin=false;
                }
                else
                {
                    this.emailMessage=res.data.msg;
                    this.emailFailed=true;

                }
            })
            .catch(err => {
            console.log(err.response);
            });
    },
    about()
    {
        this.$router.push({name:'aboutjuzzap'});

    } ,
    upper1(e) {
        //e.target.value = e.target.value.toUpperCase();

        if(this.businesscode1.length>=3)
        {
            document.getElementById('businesscode2').focus();
            return false;

        }

    },
    upper2(e) {
        //e.target.value = e.target.value.toUpperCase();
         if(this.businesscode2.length>3)
        {
            e.preventDefault();
            return ;

        }
        this.businesscode2=this.businesscode2.toUpperCase();
        if(this.businesscode2.length==3)
        {
            document.getElementById('businesscode3').focus();
        }

    },
    upper3(e) {
         if(this.businesscode3.length>3)
        {
            e.preventDefault();
            return ;

        }
        //e.target.value = e.target.value.toUpperCase();
        this.businesscode3=this.businesscode3.toUpperCase();


    },

    submitlogin()
    {
        if(this.$validator.validateAll())
        {
            let email = this.email;
            let password = this.password;
            this.overlaylogin=true;

            this.$store
            .dispatch("loginuser", { email, password })
            .then(() => {
                console.log('no error');
                let user = JSON.parse(localStorage.getItem("user") || "{}");

                if (localStorage.getItem("user").length>0)
                {
                    console.log('Login');
                    this.authFailed = false;
                    this.authMessage='';

                    let user = JSON.parse(localStorage.getItem("user") || "{}");
                        if (Object.keys(user).length !== 0)
                        {
                        if (user.userType == "agent")
                            {
                                this.$router.push("/agent/dashboard");
                            }
                        if(user.userType=='business')
                        {
                            //this.$router.push("/businessdashboard");
                            this.$router.push({name:'dashboardbusiness'});


                        }
                        if(user.userType=='user')
                        {
                            if (this.code!='')
                            {
                            this.$router.push({name:'businesshome',params:{code: this.code}});
                            }else{
                            console.log("usedashboard");

                            if(this.getCookie('jzuserkey')!='')
                            {
                                this.$router.push({name:'userdashboard',params:{ukey: this.getCookie('jzuserkey')}});
                            }
                            else{
                                this.$router.push({name:'userdashboard'});

                            }
                            }

                            //this.$router.push("/businesshome");
                        }
                        }

                }
                else
                {
                    // if(this.$store.getters.isLoggedinMsg!='')
                    // {
                    //     this.authFailed = true;
                    //     this.authMessage=this.$store.getters.isLoggedinMsg;
                    //     this.overlaylogin=false;
                    //     console.log(this.$store.getters.isLoggedinMsg);
                    // }
                    // else
                    // {
                    this.authFailed = true;
                    this.authMessage="User not registered";
                    this.overlaylogin=false;
                    console.log('error');
                    //}
                }
            })
            .catch(err => {


            this.authMessage=localStorage.getItem('isLoggedinMsg');


            this.overlaylogin=false;

              console.log('err section',err.response);
              this.authFailed = true;
              if (!err.data.success) {
                this.authMessage = err.data.message;
              }
            });
        }
        else{

        }
    },

    getCookie(cname)
    {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    },
    submit()
    {
        let th = this;
        if (this.businesscode.trim().length==4)
        {
            this.codeError=false;
            let fd = new FormData(document.getElementById("frontform"));

            this.$http
            .get(this.$apidomain+"checkbusinesscode/" + this.businesscode)
            .then(res => {
                if (res.data.success == 1)
                {
                    //this.$router.push({name:'businesshome',params:{code: this.businesscode.trim(),type:'uc',key:this.getCookie('jzuserkey')}});
                    //this.$router.push({name:'bDetails',params:{tag:  this.businesscode,key:this.getCookie('jzuserkey')}});

                    this.$router.push({name:'food',params:{tag:  this.businesscode,key:this.getCookie('jzuserkey')}});

                }
                else
                {
                    this.codeError=true;
                    this.businesscode='';

                }
            })
            .catch(err => {
            console.log(err.response);
            });

            this.$http.post('https://api.juzzap.com/api/inserttaganalitics/'+ this.businesscode+'/pin')
                .then(res=>{

                })
                .catch(err=>{
                console.log(err.response);
                });



        }
        else{
            this.codeError=true;
            this.businesscode='';
        }
    } ,
    login()
    {

        if(this.hideLogin)
        {
            this.hideLogin=false;
        }else{
            this.hideLogin=true;
        }
    },
    register()
    {
        //this.$router.push("/registeroption");
        this.$router.push("/businesstype");
    },
  },
}
</script>
<style scoped>
.subhead{
    padding-top:20px;
    font-size:25px;
}
.heading-cong
{
    color:#FE5800;
    font-size:40px;
}
.mt-50
{
    margin-top:50px !important;
}
.theme--light.v-application {
    background: #fff;

}
.pwa-content{
    margin-top: -60px;
}
.custom-placeholer-color input::placeholder {
  color: red!important;
  opacity: 1;
}

.custom-label-color .v-label {
  color: red;
  opacity: 1;
}

.pin-separator{
    font-size:20px;
}
.pin-box{
    font-size:20px;
    padding: 8px 12px;
    width:100%;
    border: 1px solid #dddddd;
    text-align: center;
}
.max-400{
    max-width: 400px;
}
.full-screen{
    height:100vh;
    width:100vw;
}
.hkeep{
    font-size: clamp(30px, 3vw, 60px);
    font-weight: bold;
}
.true-center{
    display: grid;
    place-items: center;

}
.true-center{
  display: grid;
  place-items: center;
  height: 100vh;
}
.full-screen{
    height:100vh;
    width:100vw;
}
.icon-col{
    color: #fe5800 !important;
    height: 25px;
}

.txt1{
    font-size: 20px;
    font-weight: 800;
    line-height: .9;
    color: rgb(69, 69, 69);
    text-align: center;
}
.txt2{
    font-size: 12px;
    text-align: center;
}
.txt3{
    font-size: 10px;
    font-weight: 500;
    color: #fe5800;
    text-transform: uppercase;
}
.txtsub{
    font-size: 14px;
    font-weight: 400;
    color: #000000;
}
</style>
